import { autoUpdate, flip, offset, shift, useFloating } from '@floating-ui/vue'

import type { CSSProperties } from 'vue'

interface MenuNavItemOptions {
  active: Ref<boolean>
  hasChildren: Ref<boolean>
}

interface MenuNavItemReturn {
  itemRoot: Ref<HTMLElement | null>
  submenu: Ref<HTMLElement | null>
  isHovered: Ref<boolean>
  submenuStyle: ComputedRef<CSSProperties | undefined>
  setHovered: (value: boolean) => void
}

export const useMenuNavItem = ({ active, hasChildren }: MenuNavItemOptions): MenuNavItemReturn => {
  const SAFE_PADDING = 8

  const itemRoot = ref<HTMLElement | null>(null)
  const submenu = ref<HTMLElement | null>(null)
  const isHovered = ref<boolean>(false)

  const { floatingStyles } = useFloating(itemRoot, submenu, {
    placement: 'right-start',
    middleware: [
      offset(0),
      flip({ fallbackPlacements: ['right-end'] }),
      shift({ padding: SAFE_PADDING }),
    ],
    whileElementsMounted: autoUpdate,
  })

  const submenuStyle = computed<CSSProperties | undefined>(() =>
    !active.value && hasChildren.value ? floatingStyles.value : undefined,
  )

  const setHovered = (value: boolean): void => {
    isHovered.value = value
  }

  return {
    itemRoot,
    submenu,
    isHovered,
    submenuStyle,
    setHovered,
  }
}
